import { FilterItemDto } from '../request/filter-item.dto';
import { SorterItemDto } from '../request/sorter-item.dto';

/** Query params for `GET /api/app/notification`. `status` is this endpoint's own extra filter on top of the shared list-request shape. */
export class NotificationListRequestDto {
  status: string | null = null;
  filters: FilterItemDto[] = [];
  sorters: SorterItemDto[] = [];
  skipCount = 0;
  maxResultCount = 10;
}
